export const categories = [
  { id: 'category-1', name: '恋爱韩漫', slug: 'romance', count: 42, icon: 'ri-heart-line' },
  { id: 'category-2', name: '奇幻韩漫', slug: 'fantasy', count: 38, icon: 'ri-magic-line' },
  { id: 'category-3', name: '动作韩漫', slug: 'action', count: 35, icon: 'ri-sword-line' },
  { id: 'category-4', name: '悬疑韩漫', slug: 'thriller', count: 28, icon: 'ri-search-eye-line' },
  { id: 'category-5', name: '搞笑韩漫', slug: 'comedy', count: 31, icon: 'ri-emotion-laugh-line' },
  { id: 'category-6', name: '剧情韩漫', slug: 'drama', count: 45, icon: 'ri-film-line' },
  { id: 'category-7', name: '耽美韩漫', slug: 'bl', count: 25, icon: 'ri-user-heart-line' },
  { id: 'category-8', name: '百合韩漫', slug: 'gl', count: 18, icon: 'ri-women-line' },
];

export const comics = [
  {
    id: 'comic-1',
    title: '我的野蛮王妃',
    slug: 'my-sassy-princess',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%20art%20style%2C%20beautiful%20female%20character%20with%20long%20dark%20hair%2C%20royal%20palace%20background%2C%20soft%20warm%20lighting%2C%20romantic%20atmosphere%2C%20elegant%20dress%2C%20Korean%20webtoon%20illustration%20style%20with%20clean%20lines%20and%20vibrant%20colors%2C%20simple%20white%20background%20with%20subtle%20floral%20elements&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    description: '一位现代女孩意外穿越到朝鲜王朝，成为太子妃。在宫廷的尔虞我诈中，她凭借现代人的智慧与幽默，一步步赢得太子的心，也改变了历史的走向。',
    category: 'romance',
    author: '金惠珍',
    status: '连载中',
    rating: 9.5,
    views: 1286000,
    chapters: 87,
    tags: ['穿越', '宫廷', '甜宠', '古风'],
    featured: true,
    trending: true,
    updatedAt: '2026-08-03',
  },
  {
    id: 'comic-2',
    title: '暗黑之塔',
    slug: 'dark-tower',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20cover%2C%20mysterious%20dark%20tower%20silhouette%20against%20purple%20sky%2C%20male%20protagonist%20with%20magical%20aura%2C%20fantasy%20adventure%20theme%2C%20dramatic%20lighting%2C%20Korean%20webtoon%20illustration%20style%2C%20clean%20white%20background%20with%20subtle%20magic%20sparkles&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    description: '在一个被黑暗笼罩的世界，一座神秘的高塔是唯一的希望。少年艾伦背负着家族使命，踏上了攀登塔顶的冒险之旅，每一层都隐藏着不可告人的秘密。',
    category: 'fantasy',
    author: '朴志勋',
    status: '连载中',
    rating: 9.7,
    views: 2150000,
    chapters: 124,
    tags: ['冒险', '魔法', '成长', '黑暗奇幻'],
    featured: true,
    trending: true,
    updatedAt: '2026-08-04',
  },
  {
    id: 'comic-3',
    title: '格斗之王',
    slug: 'fighting-king',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20cover%2C%20muscular%20fighter%20in%20dynamic%20pose%2C%20martial%20arts%20combat%20scene%2C%20intense%20expression%2C%20dramatic%20energy%20effects%2C%20Korean%20webtoon%20illustration%20style%2C%20clean%20white%20background%20with%20action%20lines&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    description: '地下格斗界的传奇拳手李泰成，在一次意外中失去了右手。但他没有放弃，以更加残酷的训练重新站上擂台，用拳头捍卫属于自己的荣耀。',
    category: 'action',
    author: '崔正宇',
    status: '已完结',
    rating: 9.3,
    views: 1890000,
    chapters: 156,
    tags: ['格斗', '热血', '励志', '竞技'],
    featured: true,
    trending: true,
    updatedAt: '2026-07-28',
  },
  {
    id: 'comic-4',
    title: '第七个夜晚',
    slug: 'seventh-night',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20cover%2C%20mysterious%20woman%20in%20dark%20alley%2C%20suspenseful%20mood%2C%20rainy%20night%20scene%2C%20shadowy%20figure%2C%20Korean%20webtoon%20illustration%20style%2C%20clean%20composition%20with%20dramatic%20contrast%2C%20white%20border%20with%20dark%20atmosphere&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    description: '连续六天，小镇上发生了六起离奇死亡事件。第七天，刑警韩秀雅收到了来自凶手的第七封预告信。她必须在第七个夜晚到来之前，揭开连环杀人案的真相。',
    category: 'thriller',
    author: '李秀敏',
    status: '连载中',
    rating: 9.6,
    views: 967000,
    chapters: 62,
    tags: ['悬疑', '犯罪', '推理', '心理'],
    featured: true,
    trending: false,
    updatedAt: '2026-08-02',
  },
  {
    id: 'comic-5',
    title: '废柴逆袭记',
    slug: 'loser-revenge',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20cover%2C%20funny%20male%20character%20with%20exaggerated%20expression%2C%20comedic%20pose%2C%20bright%20colorful%20style%2C%20office%20setting%2C%20Korean%20webtoon%20illustration%20style%2C%20clean%20white%20background%20with%20humorous%20elements&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    description: '三十岁无业游民金大浩，在一次意外中获得了一个神奇的系统。从此开启了啼笑皆非的逆袭人生。曾经看不起他的人，如今都要仰望他。',
    category: 'comedy',
    author: '郑明勋',
    status: '连载中',
    rating: 9.4,
    views: 3120000,
    chapters: 198,
    tags: ['搞笑', '系统流', '逆袭', '都市'],
    featured: false,
    trending: true,
    updatedAt: '2026-08-04',
  },
  {
    id: 'comic-6',
    title: '皇后的秘密',
    slug: 'queens-secret',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20cover%2C%20elegant%20queen%20in%20traditional%20hanbok%2C%20palace%20intrigue%20atmosphere%2C%20serious%20expression%2C%20royal%20Korean%20court%20setting%2C%20Korean%20webtoon%20illustration%20style%2C%20clean%20white%20background%20with%20subtle%20traditional%20patterns&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    description: '朝鲜王朝最年轻的中殿娘娘，表面温婉贤淑，暗地里却是一代剑术高手。当朝廷陷入危机，她将用隐藏多年的真实身份，守护这个国家的未来。',
    category: 'drama',
    author: '尹素英',
    status: '连载中',
    rating: 9.6,
    views: 1750000,
    chapters: 95,
    tags: ['宫廷', '权谋', '武侠', '女性向'],
    featured: true,
    trending: true,
    updatedAt: '2026-08-03',
  },
  {
    id: 'comic-7',
    title: '星光下的约定',
    slug: 'starlight-promise',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20BL%20cover%2C%20two%20handsome%20male%20characters%20under%20starry%20night%20sky%2C%20romantic%20atmosphere%2C%20tender%20moment%2C%20Korean%20webtoon%20illustration%20style%2C%20clean%20white%20background%20with%20subtle%20star%20sparkles&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    description: '高中时期的一场意外让两人分离。十年后，已成为天文学家的智勋，在观测站再次遇见了曾是初恋的泰民。星空之下，他们能否重拾那份未完成的约定？',
    category: 'bl',
    author: '宋河英',
    status: '已完结',
    rating: 9.5,
    views: 856000,
    chapters: 72,
    tags: ['纯爱', '重逢', '职场', '治愈'],
    featured: false,
    trending: false,
    updatedAt: '2026-07-15',
  },
  {
    id: 'comic-8',
    title: '花与荆棘',
    slug: 'flower-and-thorn',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20GL%20cover%2C%20two%20beautiful%20female%20characters%20surrounded%20by%20flowers%2C%20elegant%20romantic%20style%2C%20soft%20pastel%20colors%2C%20Korean%20webtoon%20illustration%20style%2C%20clean%20white%20background%20with%20floral%20elements&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    description: '花艺师允儿与刺青师瑞妍，一个是温柔的花朵，一个是尖锐的荆棘。两个截然不同的灵魂在一场展览中相遇，开始了一段既甜蜜又痛苦的爱情故事。',
    category: 'gl',
    author: '金多喜',
    status: '连载中',
    rating: 9.2,
    views: 523000,
    chapters: 48,
    tags: ['百合', '艺术', '治愈', '都市'],
    featured: false,
    trending: false,
    updatedAt: '2026-08-01',
  },
  {
    id: 'comic-9',
    title: '剑圣归来',
    slug: 'sword-master-returns',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20fantasy%20cover%2C%20sword%20master%20with%20flowing%20cape%2C%20ancient%20Korean%20warrior%20holding%20glowing%20sword%2C%20epic%20atmosphere%2C%20Korean%20webtoon%20illustration%20style%2C%20clean%20white%20background%20with%20energy%20effects&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    description: '江湖人称剑圣的独孤宇，为保护心爱之人被奸人所害。百年后，他意外重生在一个废柴少年的身上。这一次，他要让所有敌人付出代价。',
    category: 'action',
    author: '姜泰贤',
    status: '连载中',
    rating: 9.6,
    views: 2450000,
    chapters: 143,
    tags: ['重生', '武侠', '复仇', '热血'],
    featured: true,
    trending: true,
    updatedAt: '2026-08-04',
  },
  {
    id: 'comic-10',
    title: '甜心陷阱',
    slug: 'sweet-trap',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20comedy%20cover%2C%20cute%20female%20character%20with%20sweet%20smile%2C%20dessert%20shop%20background%2C%20romantic%20comedy%20vibe%2C%20warm%20pink%20tones%2C%20Korean%20webtoon%20illustration%20style%2C%20clean%20white%20background&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    description: '甜品店老板的女儿姜糖糖，继承了家族祖传的甜品秘方。冷酷总裁陆北宸无意中品尝了她的甜品后，竟然成了甜品店的常客。甜甜的爱情故事就此展开。',
    category: 'romance',
    author: '赵美妍',
    status: '连载中',
    rating: 9.3,
    views: 1580000,
    chapters: 112,
    tags: ['甜宠', '总裁', '美食', '搞笑'],
    featured: false,
    trending: true,
    updatedAt: '2026-08-03',
  },
  {
    id: 'comic-11',
    title: '末日救世主',
    slug: 'apocalypse-savior',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20action%20cover%2C%20post%20apocalyptic%20setting%2C%20survivor%20holding%20weapon%2C%20destroyed%20city%20background%2C%20dramatic%20lighting%2C%20Korean%20webtoon%20illustration%20style%2C%20clean%20white%20border&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    description: '2045年，丧尸病毒爆发，世界陷入混乱。前特种兵韩志勋带领一支幸存者小队，在末日废墟中寻找传说中的安全区。他们能成为人类的救世主吗？',
    category: 'fantasy',
    author: '李钟硕',
    status: '已完结',
    rating: 9.4,
    views: 2780000,
    chapters: 210,
    tags: ['末日', '丧尸', '生存', '热血'],
    featured: false,
    trending: false,
    updatedAt: '2026-06-20',
  },
  {
    id: 'comic-12',
    title: '替身新娘',
    slug: 'substitute-bride',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20romance%20cover%2C%20bride%20in%20white%20wedding%20dress%2C%20luxurious%20setting%2C%20dramatic%20atmosphere%2C%20emotional%20expression%2C%20Korean%20webtoon%20illustration%20style%2C%20clean%20white%20background&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    description: '为了拯救家族企业，林允儿被迫代替姐姐嫁给传闻中冷酷无情的财阀继承人车胜元。原以为是一场交易婚姻，却发现这位丈夫有着不为人知的温柔一面。',
    category: 'drama',
    author: '朴慧珍',
    status: '连载中',
    rating: 9.5,
    views: 2010000,
    chapters: 88,
    tags: ['替身', '先婚后爱', '财阀', '虐恋'],
    featured: false,
    trending: true,
    updatedAt: '2026-08-04',
  },
  {
    id: 'comic-13',
    title: '灵异侦探所',
    slug: 'paranormal-detective',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20horror%20mystery%20cover%2C%20detective%20with%20flashlight%20in%20dark%20room%2C%20ghostly%20atmosphere%2C%20supernatural%20elements%2C%20Korean%20webtoon%20illustration%20style%2C%20clean%20white%20border%20with%20eerie%20mood&width=400&height=560&seq=comic-cover-13&orientation=portrait',
    description: '拥有阴阳眼的私家侦探姜元昊开设了一家特殊的侦探所，专门处理灵异事件。从闹鬼的公寓到失踪的灵媒，每一起案件都让他离一个惊天的秘密越来越近。',
    category: 'thriller',
    author: '卢宰贤',
    status: '连载中',
    rating: 9.3,
    views: 745000,
    chapters: 55,
    tags: ['灵异', '侦探', '恐怖', '悬疑'],
    featured: false,
    trending: false,
    updatedAt: '2026-07-30',
  },
  {
    id: 'comic-14',
    title: '电竞之王',
    slug: 'esports-king',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20esports%20gaming%20cover%2C%20young%20pro%20gamer%20in%20gaming%20arena%2C%20dynamic%20competitive%20scene%2C%20colorful%20gaming%20atmosphere%2C%20Korean%20webtoon%20illustration%20style%2C%20clean%20white%20background&width=400&height=560&seq=comic-cover-14&orientation=portrait',
    description: '高中生游戏天才陈晓宇，在一次网吧比赛中被职业战队教练发掘。从校园网吧到世界总决赛，他用自己的天赋和努力，书写了一段电竞传奇。',
    category: 'action',
    author: '黄仁秀',
    status: '连载中',
    rating: 9.5,
    views: 3340000,
    chapters: 167,
    tags: ['电竞', '竞技', '青春', '热血'],
    featured: false,
    trending: true,
    updatedAt: '2026-08-04',
  },
  {
    id: 'comic-15',
    title: '魔法学院优等生',
    slug: 'magic-academy',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20magic%20school%20cover%2C%20students%20in%20magic%20academy%20uniforms%2C%20fantasy%20magic%20effects%2C%20castle%20background%2C%20Korean%20webtoon%20illustration%20style%2C%20clean%20white%20background%20with%20magical%20sparks&width=400&height=560&seq=comic-cover-15&orientation=portrait',
    description: '出身平民的艾伦凭借惊人的魔法天赋，进入了只招收贵族的皇家魔法学院。在这里，他不仅要面对贵族的歧视，还要揭开学院隐藏千年的秘密。',
    category: 'fantasy',
    author: '徐振宇',
    status: '连载中',
    rating: 9.4,
    views: 1420000,
    chapters: 103,
    tags: ['魔法', '学院', '成长', '奇幻'],
    featured: false,
    trending: true,
    updatedAt: '2026-08-02',
  },
  {
    id: 'comic-16',
    title: '微笑的恶魔',
    slug: 'smiling-devil',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20action%20cover%2C%20smiling%20villain%20character%20with%20mischievous%20expression%2C%20urban%20fantasy%20style%2C%20Korean%20webtoon%20illustration%20style%2C%20clean%20white%20background%20with%20demonic%20hints&width=400&height=560&seq=comic-cover-16&orientation=portrait',
    description: '地狱的恶魔王厌倦了无聊的统治生活，化身为人类高中生来到人间。谁知道第一天就被校园霸凌。当霸凌者发现他的真实身份后，一切变得有趣起来。',
    category: 'comedy',
    author: '权相佑',
    status: '连载中',
    rating: 9.2,
    views: 1890000,
    chapters: 76,
    tags: ['搞笑', '校园', '奇幻', '反套路'],
    featured: false,
    trending: false,
    updatedAt: '2026-07-25',
  },
];

export const categoryLabels: Record<string, string> = {
  romance: '恋爱韩漫',
  fantasy: '奇幻韩漫',
  action: '动作韩漫',
  thriller: '悬疑韩漫',
  comedy: '搞笑韩漫',
  drama: '剧情韩漫',
  bl: '耽美韩漫',
  gl: '百合韩漫',
};